<template>
  <div class="order-show">
    <div class="order-show-li">
      <h3 class="h3">订单信息</h3>
      <div class="o-s-li-m">
        <span>订单编号：{{ order.order_sn }}</span>
        <span>下单日期：{{ order.created_at }}</span>
        <span>扫码日期：{{ order.updated_at }}</span>
      </div>
    </div>
    <div class="order-show-li">
      <h3 class="h3">用户信息</h3>
      <div class="o-s-address">
        <p>ID：{{ order.user_id }}</p>
        <p>姓名：{{ order.user_name }}</p>
      </div>
    </div>
    <div class="order-show-li">
      <h3 class="h3">绑定防伪码</h3>
      <div class="o-s-address">
        <p v-for="code in order.codes">防伪码：{{ code.code }}</p>
      </div>
    </div>

    <Floating />
    <wxNoShare />
  </div>
</template>

<script>
  export default {
    name: 'ordersShow',
    data() {
      return {
        order: []
      };
    },
    created () {
      this.getOrders()
    },
    methods: {
      getOrders() {
        this.$api.get('fw/order/show', {id: this.$route.query.id}, r=>{
          this.order = r.result
        })
      }
    }
  }
</script>

<style scoped>
  .order-show{
    padding:10px;
    overflow: hidden;
  }
  .order-show-li{
    background: #ffffff;
    border-radius: 8px;
    overflow: hidden;
    padding:10px;
    margin-bottom: 10px;
  }
  .order-show-li .h3{
    margin: 0;
    font-size: 14px;
    padding-bottom: 5px;
  }
  .order-show-li .o-s-li-m{
    font-size: 14px;
  }
  .order-show-li .o-s-li-m span{
    display: block;
    line-height: 30px;
  }

  .order-show-li .o-main{
    overflow: hidden;
    margin-top: 5px;
  }
  .order-show-li .o-main .img{
    float: left;
    width: 35%;
  }
  .order-show-li .o-main .img img{
    width: 100%;
    height: 80px;
  }
  .order-show-li .o-main .info{
    float: right;
    width: 60%;
    margin-left: 5%;
  }
  .order-show-li .o-main .info h3{
    margin: 0;
    font-size: 14px;
    font-weight: normal;
    height: 40px;
  }
  .order-show-li .o-main .info .price{
    font-size: 14px;
  }
  .order-show-li .o-main .info .price .sp2{
    color:#646566;
  }
  .order-show-li .o-main .info .pay-price{
    font-size: 14px;
    margin-top: 5px;
  }
  .order-show-li .o-main .info .pay-price .p-sp-2{
    float: right;
  }
  .order-show-li .o-s-address{
    font-size: 14px;
  }
  .order-show-li .o-s-address p{
    margin: 8px 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/orders/show.vue